import { Grid } from '@mui/material'
import React from 'react'
import '../../assets/css/accountmetrics.scss'
import Title from './title'
import brp from "../../assets/images/brp.svg"
import usd from "../../assets/images/usd.svg"
import { dollarUS } from "../../utilities/formatters";



const NumberFormatter = (num, formatter=undefined) => {
  let data = parseInt(num);
  const classlist = data < 0 ? "Negative" : data >= 0 ? "Positive" : "Number";
  if(formatter) return <div className={classlist}>{formatter(num)}</div>;
  return <div className={classlist}>{num}</div>;
};

const AMStatCards = (props) => {
  return (
    <div className="AMStatCards">
      <Grid container>
        <Grid xs={2}>
          <div className="FCountry">
            <img src={usd} alt="" />
          </div>
          <div className="LCountry">
            <img src={brp} alt="" />
          </div>
        </Grid>
        <Grid>
          <Grid className="CardName">{props.AMCurrencyName}</Grid>
          <Title three>
            <span style={{ textTransform: "uppercase" }}>
              {props.AMCurrencyName}
            </span>
          </Title>
        </Grid>
      </Grid>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid className="StatNumOne">{props.Num1}</Grid>
        <Grid className="StatNumTwo">
          {NumberFormatter(props.Num3, dollarUS)}
          {NumberFormatter(props.Num2)}
        </Grid>
      </Grid>
    </div>
  );
}

export default AMStatCards